import { useMutation, MutationConfig } from 'react-query'

import {
  useBackendContext,
  BackendMutationOptions,
  BackendError,
} from '../../components/BackendContext'

export function useHumpClubMutation<TResult, TVariables>(
  key: string | [string, BackendMutationOptions?],
  config?: MutationConfig<TResult, BackendError, TVariables>,
) {
  const [path, options] = Array.isArray(key) ? key : [key]

  const { humpclubMutation } = useBackendContext()

  const _config = {
    ...config,
  }

  const query = useMutation<TResult, BackendError, TVariables>(
    humpclubMutation(path, options),
    _config,
  )

  return query
}

export default useHumpClubMutation
